import styled from '@emotion/styled';
import { hideDrag } from '../../styles/hide-drag';

export const Button = styled.button<{  primary?: boolean, loading?: boolean }>`
  min-width: 190px;
  min-height: 3em;
  height: 3em;

  padding: 0;
  outline: none;
  background-color: ${(props) => props.theme.colors.primary950};
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: opacity 300ms ease, filter 300ms ease, -webkit-filter 300ms ease;

  border: 2px solid ${(props) => props.theme.colors.primary500};
  border-radius: 2.5rem;

  ${(props) => !!props.primary && `
    background-color: ${props.theme.colors.primary500};
  `}

  ${(props) => !!props.loading && `
    cursor: wait;
  `};

  &:disabled {
    opacity: 0.6;
    cursor: no-drop;
  }

  ${hideDrag};
`;

export const TextContainer = styled.div`
  text-shadow: 0px 1px 1px #00000029;

  .ant-spin-dot-item {
    background-color: #fff;
  }

  .ant-spin-nested-loading, .ant-spin-blur, .ant-spin-container {
    height: 100%;
    width: 100%;

    border-radius: 20px;
    overflow: hidden;
  }

  &,
  .ant-spin-container {
    height: 100%;
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Text = styled.span<{ primary: boolean, whitespace: string }>`
  color: ${(props) => props.theme.colors.primary500};

  ${(props) => props.primary && `
    color: ${props.theme.colors.primary950};
  `}

  font-size: 1rem;
`;
